import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import {
  deleteData,
  findData,
  recordFiltering,
} from '~/store/modules/corredor/actions';

import CorredorForm from './form';

function Corredor() {
  const redux = useSelector((state) => state.corredor);

  const header = useMemo(
    () => [
      {
        id: 'nomecorredor',
        label: t('Nome Corredor'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findData}
      remove={deleteData}
      form={CorredorForm}
      keys="idcorredor"
      detach="idcorredor"
    />
  );
}

export default Corredor;